mainApp.directive('ipAllocationConfig', function() {
    return {
        templateUrl: '/public/directives/ipAllocationConfig.html',
        scope: {
            ipAllocationProperties : '=',

        },
        controller:  ['$scope', '$timeout', '$state',"IconsService","GeneralUtilsService","LocationService", function($scope, $timeout, $state,IconsService,GeneralUtilsService,LocationService) {

            /*
             * indicator that we currently fetching a free ip from
             * the server this variable will prevent any saving action in the
             * meanwhile
            */
            let fetchingIp = false;

            /**
             * checking if allocatedIps are changed if so
             * we emmit the egressChanged function which
             */
            $scope.$watch('allocatedIps', function(newValue, oldValue) {
                if (!_.isEqual(newValue, oldValue)) {
                    // set the change attribute
                    $scope.ipAllocationProperties.wasChanged = isIpAllocationChanged()
                }

            }, true);


            /**
             *  when the directive get a change in this property we will reload the data
             *  meaning changes were made which we would like to revert
             */
            $scope.$watch('ipAllocationProperties.reloadIpAllocationConfiguration', function(newValue, oldValue) {
                if (newValue && !_.isEqual(newValue, oldValue) && newValue == true) {
                    delete $scope.ipAllocationProperties.reloadIpAllocationConfiguration;
                    initIpAllocationConfig();
                }

            }, true);


            /**
             * loading an account on which the egress ips are
             * defined
             **/
            function loadAccount(){
                store.fetch({
                    path: "getAccountSettings",
                    queryParams: {'accountId': $state.params.accountId,'type':'account'},
                    success: function(data) {
                        handleGetAccountSettingsResponse(data);
                        $scope.$digest();
                    }
                });
            }

            const handleGetAccountSettingsResponse = (data) => {
                $scope.account = data;
                $scope.allocatedIps = angular.copy($scope.account.allocatedIps);
                $scope.publicIpsNum = $scope.account.licensedIpsToAllocate;
                while($scope.allocatedIps.length <$scope.publicIpsNum){
                    // setting location id to 0 in order to fit location array on not create a new entry
                    $scope.allocatedIps.push({locationId: 0});
                }
            }

            /**
             * method for loading locations for the account
             **/
            function loadLocations() {
            	LocationService.getPopLocations($state.params.accountId, updateLocations)
            };

            function updateLocations(data){
            	$scope.locations = data;
            }

            /**
             * initiate function for the egress directive should be called on start
             * of the egress directive
             **/
            function initIpAllocationConfig(){
                loadAccount();
                loadLocations();
                // setting the save function
                $scope.ipAllocationProperties.saveEgress = $scope.saveIpAllocation;
            }

            /**
             * counts the amount of fully defined egress entities
             * @param egressList
             * @returns {number}
             */
            function ipAllocationAmount(egressList) {
                var counter = 0;
                egressList.forEach(function (egressEntity) {
                    if(ipFullyDefined(egressEntity)){
                        counter++;
                    }
                });
                return counter;
            }

            /**
             * method for checking if error is found on ip allocation
             * section iterating all ips and checking if error is found on
             * one of them
             * @returns {boolean}
             */
            $scope.hasIpErrors = function () {
                var foundError = false;
                if($scope.allocatedIps){
                    $scope.allocatedIps.forEach(function (singleEgressIp) {
                        if(!foundError && singleEgressIp.error){
                            foundError = true;
                        }
                    });
                }
                return foundError;
            };


            /**
             * function iterating on the egress and checking if the
             * egress has changed
             * @returns {boolean}
             */
            var isIpAllocationChanged = function () {
                if(!$scope.allocatedIps || !$scope.account || $scope.hasIpErrors())
                    return;

                /*
                 * currently fetching an ip address thus we want to suspend any saving option
                 * fetchingIp will change to false when ip will be fetched
                 *
                 * that way we prevent a state of saving when ip is missing
                */
                if(fetchingIp){
                    return false;
                }

                // different amount or change in the enable button
                if(ipAllocationAmount(_.values($scope.allocatedIps)) != ipAllocationAmount($scope.account.allocatedIps))
                    return true;

                var allEgressFound = true;
                Object.keys($scope.allocatedIps).forEach(function (egressIpKey) {
                    if(allEgressFound){
                        var found = false;
                        var egressIp = $scope.allocatedIps[egressIpKey];
                        if(ipFullyDefined(egressIp)){
                            $scope.account.allocatedIps.forEach(function (compareTo) {
                                if(angular.equals(egressIp,compareTo))
                                    found = true;
                            });
                            if(!found)
                                allEgressFound = false;
                        }
                    }
                });
                return !allEgressFound;
            };

            /**
             * Fetch from server another free public IP
             * ip for the same location will be taken from different pops if possible
             **/
            $scope.egressChange = function(index) {
                // meaning we want to delete the allocation of the egress
                if($scope.allocatedIps[index].locationId== 0){
                    delete $scope.allocatedIps[index];
                    $scope.allocatedIps[index] = {locationId: 0};
                    fetchingIp = false;
                }
                // allocate egress ip
                else{
                    fetchingIp = true;
                    var allAllocatedIps = {};
                    var counter = 0;
                    // fill used egress ips
                    $scope.allocatedIps.forEach(function (egress) {
                        if(egress && egress.ip){
                            allAllocatedIps[counter]= {ip: egress.ip, popId:egress.popId };
                            counter++;
                        }
                    });

                    // send request to the server to assign new IP
                    store.fetch({
                        data: allAllocatedIps,
                        method: 'POST',
                        dataObj: 'currentIpsStr',
                        path: "getNewIP?accountId=" + $state.params.accountId,
                        queryParams: {'location': $scope.allocatedIps[index].locationId},
                        success: function(data) {
                            $timeout(() => handleGetNewIpResponse(data, index), 1, true);
                        }
                    });
                }
            };

            const handleGetNewIpResponse = (data, index) => {
                if(data == null) {
                    $scope.allocatedIps[index] = {"error":"Not enough free IP addresses in location",locationId: $scope.allocatedIps[index].locationId};
                }
                else {
                    delete $scope.allocatedIps[index].error;
                    /*
                     *  if no id is set on the egress meaning new we assign an id for the
                     *  difference between the objects
                     */
                    if(!$scope.allocatedIps[index].id)
                        $scope.allocatedIps[index].id =GeneralUtilsService.getRandomId();
                    $scope.allocatedIps[index].ip = data.ip;
                    $scope.allocatedIps[index].popId = data.popId;
                }
                fetchingIp = false;
            }

            /**
             * returns true if egress property is fully defined
             * @param egress
             * @returns {*|number}
             */
            function ipFullyDefined(egress) {
                return egress && egress.ip && egress.locationId && egress.popId;
            };


            /**
             * function for saving the egress configuration after
             * changes were mad
             */
            $scope.saveIpAllocation = function (onSuccess,onFailure) {
                if(!isIpAllocationChanged()){
                    return ;
                }

                /*
                 * we set the property by default to "True" when saving new egress this property should be deprecated
                 * after we migrated to the advance egress feature
                */
                $scope.account.eggressIpsEnabled = true;
                var origAllocatedIps = angular.copy($scope.account.allocatedIps);
                $scope.account.allocatedIps = [];

                /*
                 * if egress ip is turned off we would't like to preserve the ip addresses
                 * thus we insert the ips only if egress ips is enabled
                */
                if($scope.account.eggressIpsEnabled){
                    Object.keys($scope.allocatedIps).forEach(function (egressIpKey) {
                        var egressIp = $scope.allocatedIps[egressIpKey];
                        if(ipFullyDefined(egressIp)){
                            $scope.account.allocatedIps.push(angular.copy(egressIp));
                        }
                    });
                }

                // send save request
                $scope.account.newSaveMethod = true;
                store.save({
                    path: "/edit",
                    data: $scope.account,
                    dataObj: 'json',
                    queryParams: {
                        'accountId': $state.params.accountId,
                        'save':true,
                        'fields':"['allocatedIps','eggressIpsEnabled']"
                    },
                    success: function(data) {
                        $scope.$root.handleServerResponse(data,"ipAllocation", 'Account settings saved successfully');
                        if(data.status != "ERROR"){
                            initIpAllocationConfig();
                            // after saving we set the flag back to false
                            $scope.ipAllocationProperties.wasChanged = false;
                            onSuccess();
                        }
                        else{
                            $scope.account.allocatedIps = origAllocatedIps;
                            onFailure();
                        }

                    }
                });
            };

            // calling the egress init function
            initIpAllocationConfig();

        }]
    };
});
